import React from 'react';
import './App.css';
import Sidebar from './Sidebar';
import Chat from './Chat';
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Login from './Login';
import { useStateValue } from './StateProvider';

function App() {
  // const [user, setUser] = useState(null);
  const [{ user }, dispatch] = useStateValue();
  return (

    // BEM naming convention
    <div className="app">
      {!user ? (
        <Login />
      ) :
        <div className="app__body">
          <Router>
            <Sidebar />
            <Switch>


              <Route path="/rooms/:roomId">
                <Chat />
              </Route>
              <Route path="/">
                <Chat />
              </Route>
            </Switch>
          </Router>
        </div>
      }


    </div>
  );
}
// import { Router } from '@material-ui/icons';
// import { Switch } from '@material-ui/core';

export default App;
